import React, { useEffect, useState } from 'react'
import { History } from '../History/History'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { useParams, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import moment from 'moment'

export const Card2 = (props) => {
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  // fetch user from localstorage
  const user = localStorage.getItem('user')
  const token = localStorage.getItem('token')

  toast.configure()

  const params = useParams()

  const [clicked, setClicked] = useState(false)
  const [values, setValues] = useState()
  const [data, setData] = useState({ remarks_hr: '' })
  const [interviewer, setInterviewer] = useState([])
  const [hr, setHR] = useState([])
  const [hrStatus, setHrStatus] = useState([])
  const [finalStatus, setFinalStatus] = useState([])
  const [round, setRound] = useState([])
  const [readonly, setReadonly] = useState(false)
  const [rejected, setRejected] = useState(false)
  const [other, setOther] = useState(false)

  // get details of candidate
  const getData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'dashboard/fetchFormData',

        {
          id: params.id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        setValues(res.data.currentRoundData[0])
        if (values.offered_salary !== '' && values.offered_bonus !== '') {
          setReadonly(true)
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          logout()
        }
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // onchange func of input
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
    setData({ ...data, [name]: value })

    if (Number(value) === 3) {
      setOther(true)
    }
  }

  // get all interviewer name,interview round, final status and HR status
  const getvalues = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchInterviewerData', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setInterviewer(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
    await axios
      .get(Baseurl.nodeLocal + 'dashboard/fetchHRData', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setHR(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchHRStatus', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setHrStatus(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchInterviewRound', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setRound(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchFinalStatus', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setFinalStatus(res.data.data)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
  }
  useEffect(() => {
    getvalues()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // update details of candidate (schedule interview)
  const postData = async (e) => {
    e.preventDefault()
    await axios
      .post(
        Baseurl.nodeLocal + 'referral/updateReferralDetails',

        {
          id: params.id,
          sendRejectionEmail: rejected,
          email: values.email,
          other_reason: values.other_reason,
          template_no: values.rejection_reason,
          current_location: values.current_location,
          permanent_place: values.permanent_place,
          applied_date: values.applied_date,
          interviewer_name: values.interviewer_name,
          owner_name: values.owner_name,
          interview_round: values.interview_round,
          interview_date: values.interview_date,
          interview_time: values.interview_time,
          interview_feedback: values.interview_feedback,
          remarks_hr: values.remarks_hr,
          status_hr: values.status_hr,
          final_status: values.final_status,
          relocate_to_ahmedabad: values.relocate_to_ahmedabad,
          other_offer_on_hand: values.other_offer_on_hand,
          joinig_date: values.joinig_date,
          offered_salary: values.offered_salary,
          offered_bonus: values.offered_bonus,
          final_remarks: values.final_remarks,
          candidate_name: values.candidate_name,
          candidate_linkedin: values.candidate_linkedin,
          contact: values.contact,
          current_ctc: values.current_ctc,
          expected_ctc: values.expected_ctc,
          designation: values.designation,
          relevant_it_experience: values.relevant_it_experience,
          current_organisation: values.current_organisation,
          notice_period: values.notice_period,
          reason_for_job_change: values.reason_for_job_change,
          reference1_contact: values.reference1_contact,
          reference1_name: values.reference1_name,
          reference2_contact: values.reference2_contact,
          reference2_name: values.reference2_name,
          candidate_resume: values.candidate_resume,
          eligible_for_next_round:
            values.eligible_for_next_round === '' ||
            values.eligible_for_next_round === null
              ? 'NA'
              : values.eligible_for_next_round,
          modifierEmail: user,
          nextRoundEmailStatus: false,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
      .catch((err) => {
        toast.error(err.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
        if (err.response.status === 401) {
          logout()
        }
      })
  }
  return (
    <div>
      <div className="card mt-3 p-4 applicantCard mb-5">
        {values ? (
          <div className="row g-2">
            <h5 className="mb-4 text-primary">Interview Details</h5>
            <div className="col-md">
              {hrStatus.length > 0 ? (
                <div className="form-floating mb-2">
                  <select
                    className="form-select"
                    id="floatingSelectGrid"
                    name="status_hr"
                    defaultValue={values.status_hr}
                    onChange={handleChange}
                  >
                    <option value="Pending" disabled selected>
                      {' '}
                      Select{' '}
                    </option>
                    {hrStatus?.map((i, index) => {
                      return (
                        <option value={i.value} key={index}>
                          {i.name}
                        </option>
                      )
                    })}
                  </select>
                  <label htmlFor="floatingSelectGrid">HR Status</label>
                </div>
              ) : (
                ''
              )}

              {interviewer.length > 0 ? (
                <div className="form-floating mb-2">
                  <select
                    className="form-select"
                    id="floatingSelectGrid"
                    name="interviewer_name"
                    defaultValue={values.interviewer_name}
                    onChange={handleChange}
                  >
                    <option value="Not Assigned" disabled selected>
                      {' '}
                      Select{' '}
                    </option>
                    {interviewer?.map((i, index) => {
                      return (
                        <option value={i.email} key={index}>
                          {i.name}
                        </option>
                      )
                    })}
                  </select>

                  <label htmlFor="floatingInputGrid">Interviewer</label>
                </div>
              ) : (
                ''
              )}

              {round.length > 0 ? (
                <div className="form-floating mb-2">
                  <select
                    className="form-select"
                    id="floatingSelectGrid"
                    name="interview_round"
                    defaultValue={values.interview_round}
                    onChange={handleChange}
                  >
                    <option
                      value={
                        values.interview_round === 'Manual Applied'
                          ? values.interview_round
                          : 'Applied'
                      }
                      disabled
                      selected
                    >
                      {' '}
                      Select{' '}
                    </option>
                    {round?.map((i, index) => {
                      return (
                        <option value={i.value} key={index}>
                          {i.name}
                        </option>
                      )
                    })}
                  </select>
                  <label htmlFor="floatingSelectGrid">Interview Round</label>
                </div>
              ) : (
                ''
              )}

              <div className="form-floating mb-2">
                <input
                  type="date"
                  className="form-control"
                  id="floatingInputGrid"
                  name="interview_date"
                  defaultValue={values.interview_date}
                  //min={moment(new Date()).format('YYYY-MM-DD')}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInputGrid">Interview Date</label>
              </div>
              <div className="form-floating mb-2">
                <input
                  type="time"
                  className="form-control"
                  id="floatingInputGrid"
                  name="interview_time"
                  defaultValue={values.interview_time}
                  min={moment(new Date()).format('hh:mm a')}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInputGrid">Interview Time</label>
              </div>
              <div className="form-floating mb-2">
                <input
                  type="text"
                  className="form-control"
                  id="floatingInputGrid"
                  name="interview_feedback"
                  defaultValue={values.interview_feedback}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInputGrid">Interviewer feedback</label>
              </div>
              <div className="form-floating mb-2">
                <input
                  type="text"
                  className="form-control"
                  id="floatingInputGrid"
                  name="eligible_for_next_round"
                  defaultValue={
                    values.eligible_for_next_round === 1
                      ? 'Yes'
                      : values.eligible_for_next_round === 0
                      ? 'No'
                      : 'NA'
                  }
                  onChange={handleChange}
                />
                <label htmlFor="floatingInputGrid">
                  Consider For Next Round ? (Yes/No)
                </label>
              </div>
              <div className="form-floating mb-2">
                <input
                  type="text"
                  className="form-control"
                  id="floatingInputGrid"
                  name="remarks_hr"
                  value={data.remarks_hr}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInputGrid">Remarks from HR</label>
              </div>
            </div>
            <div className="col-md">
              <div className="form-floating mb-2">
                <select
                  className="form-select"
                  id="floatingSelectGrid"
                  name="relocate_to_ahmedabad"
                  defaultValue={values.relocate_to_ahmedabad}
                  onChange={handleChange}
                >
                  <option value="" disabled selected>
                    {' '}
                    Select{' '}
                  </option>
                  <option value={1}>Yes</option>
                  <option value={0}>No</option>
                </select>
                <label htmlFor="floatingSelectGrid">
                  Ready to relocate to Ahmedabad?
                </label>
              </div>
              <div className="form-floating mb-2">
                <select
                  className="form-select"
                  id="floatingSelectGrid"
                  name="other_offer_on_hand"
                  defaultValue={values.other_offer_on_hand}
                  onChange={handleChange}
                >
                  <option value="" disabled selected>
                    {' '}
                    Select{' '}
                  </option>
                  <option value={1}>Yes</option>
                  <option value={0}>No</option>
                </select>
                <label htmlFor="floatingSelectGrid">
                  Do you have any other offer on your hand?
                </label>
              </div>

              {finalStatus.length > 0 ? (
                <div className="form-floating mb-2">
                  <select
                    className="form-select"
                    id="floatingSelectGrid"
                    name="final_status"
                    defaultValue={values.final_status}
                    onChange={handleChange}
                  >
                    <option value="Pending" disabled selected>
                      {' '}
                      Select
                    </option>
                    {finalStatus?.map((i, index) => {
                      return (
                        <option value={i.value} key={index}>
                          {i.name}
                        </option>
                      )
                    })}
                  </select>
                  <label htmlFor="floatingSelectGrid">Final Status</label>
                </div>
              ) : (
                ''
              )}

              {values.final_status === 'Rejected' ||
              values.final_status === 'Irrelevant Profile' ||
              values.final_status === 'Location Not Matched' ||
              values.final_status === 'Salary Expectation High' ||
              values.final_status === 'Not Appeared' ||
              values.final_status === 'Declined Offer' ||
              values.final_status === 'Not Responded' ? (
                <div className="mx-2 mb-2">
                  {' '}
                  <label htmlFor="floatingSelectGrid mx-2">
                    Do you want to send rejection email to candidate?
                  </label>
                  <div className="row mx-1">
                    <div class="form-check col-md">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault"
                        onChange={() => setRejected(true)}
                      />
                      <label class="form-check-label" for="flexRadioDefault">
                        Yes
                      </label>
                    </div>
                    <div class="form-check col-md">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="flexRadioDefault2"
                        onChange={() => {
                          setRejected(false)
                          setOther(false)
                        }}
                      />
                      <label class="form-check-label" for="flexRadioDefault2">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
              {rejected ? (
                <div className="form-floating mb-2">
                  <select
                    className="form-select"
                    id="floatingSelectGrid"
                    name="rejection_reason"
                    value={values.rejection_reason}
                    onChange={handleChange}
                  >
                    <option value="Select" disabled selected>
                      Select
                    </option>
                    <option value={1}>Skillset Does Not Match</option>
                    <option value={2}>High Salary Expectations</option>
                    <option value={3}>Other</option>
                  </select>
                  <label htmlFor="floatingSelectGrid">Select Reason</label>
                </div>
              ) : (
                ''
              )}
              {other === true ? (
                <div className="form-floating mb-2">
                  <input
                    type="text"
                    className="form-control"
                    id="floatingInputGrid"
                    name="other_reason"
                    value={values.other_reason}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInputGrid">Add Reason</label>
                </div>
              ) : (
                ''
              )}
              <div className="form-floating mb-2">
                <input
                  type="text"
                  className="form-control"
                  id="floatingInputGrid"
                  name="final_remarks"
                  defaultValue={values.final_remarks}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInputGrid">Final Remarks</label>
              </div>

              <div className="form-floating mb-2">
                <input
                  type="date"
                  className="form-control"
                  id="floatingInputGrid"
                  name="joinig_date"
                  defaultValue={values.joinig_date}
                  disabled={values.final_status === 'Hired' ? false : true}
                  min={moment(new Date()).format('YYYY-MM-DD')}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInputGrid">Joining Date</label>
              </div>

              <div className="form-floating mb-2">
                <input
                  type="number"
                  className="form-control"
                  id="floatingInputGrid"
                  name="offered_salary"
                  defaultValue={values.offered_salary}
                  onBlur={handleChange}
                  step="0.0001"
                  disabled={
                    values.final_status === 'Hired' &&
                    values.offered_salary === ''
                      ? false
                      : true
                  }
                  readOnly={readonly === true ? true : false}
                />
                <label htmlFor="floatingInputGrid">Offered Salary In LPA</label>
              </div>
              <div className="form-floating mb-2">
                <input
                  type="number"
                  className="form-control"
                  id="floatingInputGrid"
                  name="offered_bonus"
                  defaultValue={values.offered_bonus}
                  onBlur={handleChange}
                  step="0.0001"
                  disabled={
                    values.final_status === 'Hired' &&
                    values.offered_bonus === ''
                      ? false
                      : true
                  }
                  readOnly={readonly === true ? true : false}
                />
                <label htmlFor="floatingInputGrid">Offered Bonus if any</label>
              </div>
              {hr.length > 0 ? (
                <div className="form-floating mb-2">
                  <select
                    className="form-select"
                    id="floatingSelectGrid"
                    name="owner_name"
                    defaultValue={values.owner_name}
                    onChange={handleChange}
                  >
                    <option value="Not Assigned" disabled selected>
                      {' '}
                      Select{' '}
                    </option>
                    {hr?.map((i, index) => {
                      return (
                        <option value={i.name} key={index}>
                          {i.name}
                        </option>
                      )
                    })}
                  </select>

                  <label htmlFor="floatingInputGrid">Assign Owner</label>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className="row mt-3 d-flex justify-content-between">
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={(e) => {
                    e.preventDefault()
                    setClicked(!clicked)
                  }}
                >
                  View History
                </button>

                <button
                  className="btn btn-primary"
                  type="submit"
                  onClick={postData}
                >
                  Update profile
                </button>
              </div>
            </div>

            <div className="row mt-5">{clicked ? <History /> : ''}</div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}
